import { Box, Flex, HStack, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsChevronRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import AdminCourseInfo from "../../../components/admin/course/newcourse/CourseInfo";
import AdminCurriculum from "../../../components/admin/course/newcourse/Curriculum";
import RegisterLine from "../../../components/trainee/register/RegisterLine";
// import AdminAdditionalInfo from "../../../components/admin/course/newcourse/AdditionalInfo";
// import Certification from "../../../components/trainee/register/Certification";
// import EducationProfile from "../../../components/trainee/register/EducationProfile";
// import KitSize from "../../../components/trainee/register/KitSize";
// import BasicDetails from "../../../components/trainer/BasicDetails";

const AdminNewCourse = () => {

    const [gender, setGender] = useState<any[]>([]);
    const navigate = useNavigate();

    const [pageState, setPagestate] = useState(0);
    const toast = useToast();

    const [courseTitle, setCourseTitle] = useState<string>();


    const pages = [
        { index: 1, component: AdminCourseInfo },
        { index: 2, component: AdminCurriculum }

    ]

    const switchPage = () => {

        const Component = pages[pageState].component;
    

        return <Component nextPage={nextPage} prePage={prePage} />

    }


    const nextPage: any = () => {
        if (pageState < pages.length) {
            let pg = pageState
            setPagestate(++pg)
        }
        localStorage.setItem("naptin_course_page_no", pageState.toString());
    }

    const prePage = () => {
        if (pageState > 0) {
            let pg = pageState
            setPagestate(--pg)
        }
        localStorage.setItem("naptin_course_page_no", pageState.toString());
    }

    useEffect(() => {
        const pageNo = localStorage.getItem("naptin_course_page_no") ?? '0'

        setPagestate(parseInt(pageNo));
    }, []);

    const clearCourseFromLocalStorage = () => {

        window.location.reload();
    }

    useEffect(() => {

        const maingender = [{
            id: '1',
            title: 'Technical'
        },
        {
            id: '2',
            title: 'Non-Technical'
        }
        ]
        setGender(maingender)

    }, []);


    return (
        <>
            <Flex>
                <Box width='18%' position='fixed' top='0' left='0' zIndex='1'>
                    <AdminSidebar />
                </Box>

                <Box width='82%' ml='18%' >
                    <AdminDashboardHeader />
                    <Flex justifyContent="center" bg='#F9F8F8' height='100%' bgSize='cover'>
                        <Box mt='50px' bg='#F9F8F8' height='auto' >


                            <Box height="3rem" width='764px' bg='white' boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)" px={8} py={2} >

                                <HStack justifyContent="center" gap="2rem" >
                                    <RegisterLine position="1" title="Course Information" bgColor={pageState === 0 ? "#EC3337" : "#FFE1E2"} textColor={pageState === 0 ? "#EC3337" : "brand.subtitle"} fontWeight={pageState === 0 ? "700" : "400"} />
                                    <BsChevronRight color="white" />
                                    {/* <RegisterLine position="2" title="Curriculum" bgColor={pageState === 1 ? "#EC3337" : "white"}  textColor={pageState === 1 ? "#EC3337" : "white"} fontWeight={pageState === 1 ? "700" : "400"} /> */}

                                </HStack>

                            </Box>
                            <Box boxShadow="base" width='764px' bg="white" mb='50px' mt={6} py={4} px={8} >

                                {
                                    switchPage()
                                }


                                {/* <Flex justifyContent="space-between" mt={6} px={6}>
                                    {
                                        pageState >= 1 ?
                                            <Button onClick={prePage} colorScheme="white" color='red' size="sm" fontSize={11} borderRadius={10} px={10}>PREVIOUS</Button> : <Box></Box>
                                    }

                                    {
                                pageState >= 0 && pageState <3 ?
                                    <Button onClick={nextPage} py='13px' px='30px'  type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>NEXT</Button> : 
                                      <Button py='13px' px='30px'  type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm' onClick={() => navigate(routes.Dashboard)}>SUBMIT</Button>
                            }


                                </Flex> */}
                            </Box>

                        </Box>
                    </Flex>


                </Box>
            </Flex>
        </>
    )
}

export default AdminNewCourse;